var map = {
	"./en/common": [
		8062,
		62
	],
	"./en/common.json": [
		8062,
		62
	],
	"./pt-br/common": [
		8742,
		742
	],
	"./pt-br/common.json": [
		8742,
		742
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5314;
module.exports = webpackAsyncContext;